import { useState, useEffect } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { setIsMobile } from "../store/slice/config/config";
import store from "../store/store";
import { getWindowWidth, isMobileScreen } from "../util/mobile";

// hook that will triger every time window size is changed,
// and triggering every 150ms timeout is set so it
// doesnt kill app with too many rerenders (can be configured)
export const useIsMobile = (): void => {
  const dispatch = useAppDispatch();
  // save current window width in the state object
  const [width, setWidth] = useState(getWindowWidth());

  useEffect(() => {
    const isCurrentMobile = store.getState().configSlice.isMobile;
    if (isCurrentMobile) {
      if (!isMobileScreen(width)) {
        dispatch(setIsMobile(false));
      }
    } else if (isMobileScreen(width)) {
      dispatch(setIsMobile(true));
    }
  }, [dispatch, width]);

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId: NodeJS.Timeout | null = null;
    const resizeListener = (): void => {
      // prevent execution of previous setTimeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => setWidth(getWindowWidth()), 150);
    };
    // set resize listener
    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
  }, []);
};
